module.exports = __webpack_public_path__ + "static/media/invest4.1e9602b2.svg";